export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkapp';
export const NAME = 'ZakazkaPracovniPozice';
export const ZAKAZKA_PP_PENDING = 'ZakazkaPracovniPozicePending';
export const ZAKAZKA_PP = 'ZakazkaPracovniPozice';
export const SPLIT_BILLING='SplitBilling';
export const LABOUR='LABOUR';
export const SERVICE_JOB_DETAILS='ServiceJobDetails';
export const SERVICE_JOB_SPLIT_BILLING='ServiceJobSplitBilling';
export const MAX_SHARE_PERCENTAGE = 100;
export const CHARGE_GROUP_CHANGED ='Charging Group Changed';
export const LO_SAVED ='Saved';
export const BULK_UPLOAD ='Bulk Upload';
export const ROW_EDIT_CLICKED = 'Row Edit Clicked';
export const IS_PARTY_LEVEL_DISCOUNT_ENABLE = 'IS_PARTY_LEVEL_DISCOUNT_ENABLE';
export const DISCOUNT_VAL = 'DISCOUNT_VAL';
export enum SPLIT_PARTY {
	INSURANCE = 2,
	CUSTOMER = 1,
	GOODWILL = 3
}
export const ZAKAZKAPP_CAMPAIGN = 'Campaign';

export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];

export const DEPENDENT_TABLES_ALL = <const>[
	ZAKAZKAPP_CAMPAIGN,
];

export const TEXT = 'TEXT';
export const PP_NR = 'PP_NR';
export const BILL_TO = 'BILL_TO';
export const NOTE = 'NOTE';
export const CAS_JDN_POC = 'CAS_JDN_POC';
export const PC_PP_SL_PO = 'PC_PP_SL_PO';
export const PC_PP_SL_PO_WITH_VAT = 'PC_PP_SL_PO_WITH_VAT';
export const IS_ADDITIONAL = 'IS_ADDITIONAL';
export const SERVICE_JOB_NAME = 'SERVICE_JOB_NAME';
export const COST_CENTER = 'COST_CENTER';
export const PC_WITHOUT_GST = 'PC_WITHOUT_GST';
export const PC_WITH_GST = 'PC_WITH_GST';
export const OSOBNI_CIS_PRIJ = 'OSOBNI_CIS_PRIJ';
export const PC_PP_SL_PRED = 'PC_PP_SL_PRED';
export const PC_VC_DPH_NAD = 'PC_VC_DPH_NAD';
export const PC_BEZ_DPH_NAD = 'PC_BEZ_DPH_NAD';
export const DISCOUNT_PERCENT = 'DISCOUNT_PERCENT';
export const VAT = 'VAT';
export const MIN_FIELD_LEVEL = 0;
export const MIN_DISCOUNT_LIMIT = 0;
export const MAX_DISCOUNT_LIMIT = 100;
export const LABOR_WARRANTY_PRICE = 'LABOR_WARRANTY_PRICE';
export const LABOR_COLS = {
	PP_NR,
	TEXT,
	BILL_TO,
	PC_PP_SL_PO,
	IS_ADDITIONAL,
	SERVICE_JOB_NAME,
	COST_CENTER,
	PC_WITHOUT_GST,
	PC_WITH_GST,
	OSOBNI_CIS_PRIJ,
	PC_PP_SL_PRED,
	PC_VC_DPH_NAD,
	PC_BEZ_DPH_NAD,
	DISCOUNT_PERCENT,
	PC_PP_SL_PO_WITH_VAT,
	VAT,
	NOTE,
	CAS_JDN_POC,
	LABOR_WARRANTY_PRICE,	
	IS_PARTY_LEVEL_DISCOUNT_ENABLE,
	DISCOUNT_VAL
};
